import { getInstance } from '@portal/repositories/securitySdkConfig';
const BASE_URL = '/transaction-limits';
const LimitsApi = {
  getAllLimits: async (): Promise<bank.TransactionLimit[]> => {
    const instance = getInstance();
    const { data } = await instance.get<bank.TransactionLimit[]>(BASE_URL);
    return data;
  },

  updateLimit: async (
    { amount, limitType, periodType, transactionType }: bank.TransactionLimit,
    pin: string
  ) => {
    const instance = getInstance();
    const { data } = await instance.post<bank.TransactionLimit>(BASE_URL, {
      transactionLimit: {
        amount,
        limitType,
        periodType,
        transactionType,
      },
      authenticate: {
        pin,
      },
    });
    return data;
  },
};
export default LimitsApi;
